var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLogout24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_logout24x24",
    transform: "translate(-3 -3.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M-1987.965,16A2.019,2.019,0,0,1-1990,14V2a2.019,2.019,0,0,1,2.035-2h6.1a.669.669,0,0,1,.476.193.674.674,0,0,1,.2.474.674.674,0,0,1-.2.474.668.668,0,0,1-.476.192h-6.1a.673.673,0,0,0-.678.667V14a.673.673,0,0,0,.678.666h6.1a.672.672,0,0,1,.677.667.672.672,0,0,1-.677.667Zm8.684-3.442a.681.681,0,0,1,.006-.961l2.945-2.916h-7.891a.675.675,0,0,1-.479-.2.681.681,0,0,1-.2-.481.681.681,0,0,1,.2-.481.676.676,0,0,1,.479-.2h7.891l-2.944-2.916a.679.679,0,0,1-.2-.479.68.68,0,0,1,.2-.482.676.676,0,0,1,.957-.007l4.121,4.08A.683.683,0,0,1-1974,8a.682.682,0,0,1-.2.484l-4.121,4.08a.671.671,0,0,1-.476.2.673.673,0,0,1-.482-.2Z",
    transform: "translate(1993 3.001)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLogout24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_logout24x24.3b310b2c7dd70a7dfa86fb802f365132.svg";